import { render, staticRenderFns } from "./GiftCardManagerEdit.vue?vue&type=template&id=5878fe39&"
import script from "./GiftCardManagerEdit.vue?vue&type=script&lang=js&"
export * from "./GiftCardManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports